import styled from '@emotion/styled';
import { Alert } from '@tablekit/alert';

import { card } from './common.styles';
import { BREAKPOINTS } from './constants';

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l4);
  ${card};
  padding: var(--spacing-l6);
  text-align: left;

  input {
    -webkit-appearance: none;
  }
`;

export const AuthFormWrapper = styled(FormWrapper)`
  width: 400px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: var(--spacing-l7);

  @media (max-width: ${BREAKPOINTS.mobile}) {
    width: calc(100% - 32px);
    margin-left: var(--spacing-l4);
    margin-right: var(--spacing-l4);
  }
`;

export const FormFooter = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: var(--spacing-l2);
`;

export const FormAlert = styled(Alert)`
  width: 100%;
  min-width: 100px;
  max-width: initial;
`;
